module.exports = __webpack_public_path__ + "img/photo-66.3cf303c7.webp";